import { Building, User2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { StyledTabs, type StyledTabItem } from "~/components/styled-tabs";
import { useProjects } from "~/pages/projects/contexts/projects-context";

type ProjectsTab = "myProjects" | "allProjects";

export const PreHeader = () => {
  const { showOnlyMyProjects, setShowOnlyMyProjects } = useProjects();
  const { t } = useTranslation(["components"]);

  const tabs: StyledTabItem<ProjectsTab>[] = [
    {
      value: "myProjects",
      icon: <User2 size={20} />,
      label: t("components:projectsTable.myProjects"),
    },
    {
      value: "allProjects",
      icon: <Building size={20} />,
      label: t("components:projectsTable.allProjects"),
    },
  ];

  return (
    <StyledTabs<ProjectsTab>
      activeTab={showOnlyMyProjects ? "myProjects" : "allProjects"}
      onTabChange={(value) => setShowOnlyMyProjects(value === "myProjects")}
      tabs={tabs}
      navigationClassName="justify-end"
    />
  );
};
